module.exports = __webpack_public_path__ + "img/2_247.c72d20b5.png";